// extracted by mini-css-extract-plugin
module.exports = {"forgotPasswordButton":"AuthForm_forgotPasswordButton__3H_G2","switchMessage":"AuthForm_switchMessage__1uDKy","inlineButton":"AuthForm_inlineButton__22Fsu"};